export const MAX_CONTENT_WIDTHS = {
  MEDIUM: 'medium', // 992px
  LARGE: 'large', // 1280px
  EXTRA_LARGE: 'extraLarge' // 1800px
}
